module.exports = __webpack_public_path__ + "img/processor.3b437555.png";